"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesignedMicroOrganisms = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
class DesignedMicroOrganisms extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.DESIGNED_MICRO_ORGANISMS,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.MICROBE],
            cost: 16,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.temperature(-14).max()),
            metadata: {
                cardNumber: '155',
                description: 'It must be -14 C or colder. Increase your Plant production 2 steps.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.plants(2));
                }),
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.PLANTS, 2);
        return undefined;
    }
}
exports.DesignedMicroOrganisms = DesignedMicroOrganisms;
//# sourceMappingURL=DesignedMicroOrganisms.js.map